import { useEffect } from "react";
import PropTypes from "prop-types";

function FreshdeskChat({ token, host }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://wchat.freshchat.com/js/widget.js`;
    script.async = true;
    script.onload = () => {
      window.fcWidget.init({
        token,
        host,
      });
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
      window.fcWidget?.destroy();
    };
  }, [token, host]);

  return null;
}

FreshdeskChat.propTypes = {
  token: PropTypes.string.isRequired,
  host: PropTypes.string.isRequired,
};

export default FreshdeskChat;
